export default "__VITE_ASSET__DAcFWP6N__"